import { User } from "contexts/types/application-context-types";

export const isColomboUser = (user: User) =>
  !!user?.userData?.customerCodigoNova?.startsWith("1309");
